<template>
    <div>
        <info-modal
            ref="infoModal"
            @ok-submit="closeWindow"
            :msg="infoMsg"
        />

        <liff-error-modal
            ref="errorModal"
            @ok-submit="closeWindow"
            :msg="errorMsg"
        />

        <liff-submit-error-modal
            ref="submitErrorModal"
            @ok-submit="closeWindow"
            :msg="errorMsg"
        />

        <div v-if="isLoading" class="background-loading">
        </div>
        <div>
            <check-in-by-location
                @submit="submit"
                @errorModal="errorModal"
                :lineIdToken="lineIdToken"
                header="Check In / Out"
                isUploadFile
                ref="checkInByLocation"
            ></check-in-by-location>
        </div>
    </div>
</template>

<script>
import CheckInByLocation from '@/components/liff/CheckInByLocation'
import LiffErrorModal from '@/components/modal/LiffErrorModal'
import LiffSubmitErrorModal from '@/components/modal/LiffSubmitErrorModal'
import InfoModal from '@/components/modal/InfoModal'
import axios from 'axios'
export default {
    name: 'CheckIn',
    components: {
        InfoModal,
        CheckInByLocation,
        LiffErrorModal,
        LiffSubmitErrorModal
    },

    data () {
        return {
            lineIdToken: null,
            errorMsg: '',
            infoMsg: 'infoMsg',
            hasPermission: true,
            isLoading: true
        }
    },

    methods: {
        async getCheckInByLinePermission () {
            const body = {
                lineIdToken: this.lineIdToken
            }

            const res = await axios.post(`${process.env.VUE_APP_BACKEND}/check-in-by-line/permission`, body)
            if (res && res.data && res.data.status === 'ok') {
                this.hasPermission = res.data.data
                this.isLoading = false
                if (this.hasPermission) {
                    try {
                        this.$refs.checkInByLocation.getLocation()
                    } catch (e) {
                        this.errorModal(this.$vuetify.lang.t('$vuetify.checkinOnsite.getLocationError'))
                    }
                } else {
                    this.errorModal(this.$vuetify.lang.t('$vuetify.checkInLocation.hasNoPermission'))
                }
            } else if (res && res.data && res.data.status === 'error') {
                this.errorModal(res.data.msg)
            } else {
                this.errorModal(this.$vuetify.lang.t('$vuetify.checkinOnsite.networkError'))
            }
        },

        async submit (data) {
            const form = {
                lineIdToken: this.lineIdToken,
                address: data.address,
                lat: data.lat,
                lon: data.lon,
                attachmentFile: data.attachmentFile,
                mapFile: data.mapFile
            }

            const res = await axios.post(`${process.env.VUE_APP_BACKEND}/receive-alarm/line`, form, {
                headers: { 'Accept-Language': this.$vuetify.lang.current }
            })
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                this.infoMsg = this.$vuetify.lang.t('$vuetify.checkinOnsite.msgSuccess')
                this.$refs.infoModal.dialog = true
            } else {
                this.submitErrorModal(res.data.msg)
            }
        },

        closeWindow () {
            this.$liff.closeWindow()
        },

        errorModal (message) {
            this.$store.dispatch('setLoading', false)
            this.$refs.errorModal.dialog = true
            this.errorMsg = message
        },

        submitErrorModal (message) {
            this.$store.dispatch('setLoading', false)
            this.$refs.submitErrorModal.dialog = true
            this.errorMsg = message
        },

        errorAlert () {
            this.errorModal(this.$vuetify.lang.t('$vuetify.checkinOnsite.msgGPSError'))
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        try {
            this.lineIdToken = await this.$util.getLineIdToken(process.env.VUE_APP_LINE_CHECK_IN_LIFF)
            await this.getCheckInByLinePermission()
        } catch (error) {
            this.errorModal(this.$vuetify.lang.t('$vuetify.checkinOnsite.cannotGetLineId'))
        }
        this.$store.dispatch('setLoading', false)
    }
}
</script>

<style lang="scss" scoped>
.no-permission {
    height: 100vh;
    background-color: #f7f7f7;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 3rem;
}

.no-permission-text {
    margin-top: 2rem;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: normal;
    text-align: center;
    color: #131410;
    font-family: LexendDeca;
}

.background-loading {
    height: 100vh;
    background-color: #f7f7f7;
    position: fixed;
    z-index: 100;
    width: 100vw;
}
</style>
